import * as moment from "moment";

enum DateStrBrand { }

export type DateStr = (string & DateStrBrand) | string;

function checkValidDateStr(str: string): str is DateStr {
    return moment(str).isValid();
}

export function toDateStr(date: Date | moment.Moment | string, asUTC: boolean = false): DateStr {
    if (date === null) return null;
    if (typeof date === "string") {
        if (checkValidDateStr(date)) {
            if (asUTC) {
                return moment.utc(date).toJSON();
            } else {
                return moment(date).toJSON();
            }
        } else {
            throw new Error(`Invalid date string: ${date}`);
        }
    } else {
        const dateString = asUTC ? moment.utc(date).toJSON() : moment(date).toJSON();
        if (checkValidDateStr(dateString)) {
            return dateString;
        }
    }
    throw new Error(`Shouldn't get here (invalid toDateStr provided): ${date}`);
}

export function toDate(dateStr: DateStr): Date {
    if (dateStr === null || (typeof dateStr !== "undefined" && dateStr.length === 0)) {
        return null;
    }
    const dateMoment = toMoment(dateStr);
    return !dateMoment ? null : dateMoment.toDate();
}

export function momentNow(): moment.Moment {
    return moment();
}

export function toMoment(date: DateStr | Date, asUTC: boolean = false): moment.Moment {
    if (!date) return null;
    if (asUTC) {
        return moment.utc(date);
    } else {
        return moment(date);
    }
}
